
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequiref920"];
var parcelRegister = parcelRequire.register;
parcelRegister("fFSAN", function(module, exports) {

$parcel$export(module.exports, "LanguageSelector", function () { return (parcelRequire("hMwKo")).LanguageSelector; });

var $hMwKo = parcelRequire("hMwKo");

});
parcelRegister("hMwKo", function(module, exports) {

$parcel$export(module.exports, "LanguageSelector", function () { return $fda02c5e4974a382$export$ddd501dda1f62236; });

var $loA2J = parcelRequire("loA2J");

var $f6qj2 = parcelRequire("f6qj2");

var $4wAIt = parcelRequire("4wAIt");

var $l02PV = parcelRequire("l02PV");
const $fda02c5e4974a382$export$ddd501dda1f62236 = ({ selectedLanguage: selectedLanguage, onLanguageChangeHandler: onLanguageChangeHandler, className: className, testId: testId })=>{
    const intl = (0, $f6qj2.default)();
    if (!selectedLanguage) selectedLanguage = intl.locale || "en";
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4wAIt.default), {
        name: "global-footer-v2-language-selector",
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $l02PV.default), {
            selectedLanguage: selectedLanguage,
            onLanguageChangeHandler: onLanguageChangeHandler,
            className: className,
            testId: testId
        })
    });
};

});
parcelRegister("l02PV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $867a132a6944e265$export$2e2bcd8739ae039; });
/* language-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $f6qj2 = parcelRequire("f6qj2");

var $4hU6i = parcelRequire("4hU6i");
var $1K6UN = parcelRequire("1K6UN");

var $4wAIt = parcelRequire("4wAIt");

var $aJi6x = parcelRequire("aJi6x");

var $9Dbz6 = parcelRequire("9Dbz6");

var $gDvNw = parcelRequire("gDvNw");
/**
 * Custom React-Select's Control component to allow adding the globe icon.
 */ const $867a132a6944e265$var$Control = ({ children: children, ...props })=>{
    // @ts-ignore
    const { isMouseOver: isMouseOver } = props.selectProps;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $4hU6i.c).Control, {
        ...props,
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $gDvNw.LanguageGlobeIcon), {
                color: isMouseOver ? "#172b4d" : "#42526e"
            }),
            children
        ]
    });
};
/**
 * Custom React-Select's DropdownIndicator component to update the arrow icon.
 */ const $867a132a6944e265$var$DropdownIndicator = (props)=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $4hU6i.c).DropdownIndicator, {
        ...props,
        children: "\u25BE"
    });
};
/**
 * Styles for the LanguageSelector container div.
 */ const $867a132a6944e265$var$languageSelectorContainerStyle = null;
/**
 * Global footer's language selector component.
 * Uses React-Select to render the language selector with custom styling and on mouseover behavior.
 * Dropdown menu and the options have the same styling as WPL DropdownSelector.
 *
 * @param selectedLanguage - The selected language. Defaults to 'en'.
 * @param onChangeHandler - The function to call when a different language is selected.
 * @param className - The class name to apply to the container div.
 */ const $867a132a6944e265$var$LanguageSelector = ({ selectedLanguage: selectedLanguage = "en", onLanguageChangeHandler: onLanguageChangeHandler, className: className, testId: testId })=>{
    const intl = (0, $f6qj2.default)();
    const [isMouseOver, setMouseOver] = (0, $iSvIT.useState)(false);
    const elementID = "language-dropdown";
    if (!onLanguageChangeHandler) onLanguageChangeHandler = (newLocale)=>{
        // check if there is already a locale in the path
        const { path: path } = (0, $9Dbz6.parseRoute)(window.location);
        // exclude trailing slash in the case of the home page
        window.location.href = path.length ? `/${newLocale}/${path}` : `/${newLocale}`;
    };
    const languageSelectStyle = {
        container: (provided)=>({
                ...provided,
                appearance: "none",
                flexDirection: "row",
                fontSize: "0.875rem;",
                textAlign: "left"
            }),
        control: (provided, state)=>({
                ...provided,
                color: isMouseOver ? "#172b4d" : "#42526e",
                cursor: isMouseOver ? "pointer" : "default",
                display: "inline-flex",
                border: state.isFocused ? `2px solid #4c9aff` : "2px solid transparent"
            }),
        valueContainer: (provided)=>({
                ...provided,
                marginLeft: "var(--ds-space-050, 4px)",
                textDecorationLine: isMouseOver ? "underline" : "none"
            }),
        indicatorsContainer: (provided)=>({
                ...provided,
                marginLeft: "var(--ds-space-050, 4px)"
            }),
        dropdownIndicator: (provided)=>({
                ...provided,
                fontSize: "1.5rem",
                height: "40px"
            }),
        menu: (provided)=>({
                ...provided,
                marginTop: "var(--ds-space-050, 4px)",
                boxShadow: "0px 3px 5px 0px #091E4233",
                background: "#ffffff",
                borderRadius: "var(--ds-space-050, 4px)",
                width: "5.5rem"
            }),
        option: (provided, state)=>({
                ...provided,
                "cursor": "pointer",
                "padding": `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
                "backgroundColor": state.isSelected ? "#b2d4ff" : state.isFocused ? "#ebecf0" : "#fafbfc",
                "color": state.isSelected ? "#0065ff" : "#172b4d",
                "&:hover": {
                    background: state.isSelected ? "#b2d4ff" : "#ebecf0"
                },
                "&:active": {
                    background: "#dfe1e5"
                }
            })
    };
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $loA2J.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $aJi6x.default), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)("label", {
                    htmlFor: elementID,
                    children: intl.formatMessage({
                        defaultMessage: "Language selector",
                        id: "globalFooter.bottom.language-selector.label"
                    })
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c116y",
                    className
                ]),
                "data-testid": testId,
                onMouseEnter: ()=>setMouseOver(true),
                onMouseLeave: ()=>setMouseOver(false),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4wAIt.default), {
                    name: "global-footer-v2-language-selector-component",
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $1K6UN.default), {
                        inputId: elementID,
                        defaultValue: (0, $gDvNw.languages).find((language)=>language.value === selectedLanguage),
                        options: (0, $gDvNw.languages),
                        onChange: (selectedOption)=>{
                            selectedOption && selectedOption.value !== selectedLanguage && onLanguageChangeHandler?.(selectedOption.value);
                        },
                        unstyled: true,
                        // @ts-ignore
                        isMouseOver: isMouseOver,
                        onMenuClose: ()=>setMouseOver(false),
                        "aria-label": intl.formatMessage({
                            defaultMessage: "Choose your language",
                            id: "globalFooter.bottom.language-selector"
                        }),
                        components: {
                            Control: $867a132a6944e265$var$Control,
                            DropdownIndicator: $867a132a6944e265$var$DropdownIndicator
                        },
                        styles: languageSelectStyle,
                        menuPlacement: "auto"
                    })
                })
            })
        ]
    });
};
var $867a132a6944e265$export$2e2bcd8739ae039 = $867a132a6944e265$var$LanguageSelector;

});



parcelRegister("ebyHi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a53d01ef0519e78d$export$2e2bcd8739ae039; });

var $9Ecwd = parcelRequire("9Ecwd");
function $a53d01ef0519e78d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a53d01ef0519e78d$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a53d01ef0519e78d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $9Ecwd.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a53d01ef0519e78d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("bZcXh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8b9f70d243a7264d$export$2e2bcd8739ae039; });
function $8b9f70d243a7264d$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});


//# sourceMappingURL=language-selector.ddae49d0.js.map
